import { createTypedHooks } from 'easy-peasy';
import { Model } from '../store/easypeasy/model';

const { useStoreState, useStoreActions } = createTypedHooks<Model>();

export { useStoreState, useStoreActions };
